import { RequestService } from '../../../../../common/services/RequestService';
import { BRANDS_GET } from '../../constants';

export const getBrandsRequest = payload => {
  return RequestService.get(BRANDS_GET);
};
